module.exports = __webpack_public_path__ + "static/1 (7)-c2da13d948dde779545ef6520b911783.png";